import { EditIcon } from '@approvalmax/ui';
import { Box, Button, Dropdown, Flex, TextField } from '@approvalmax/ui/src/components';
import { FC, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { renameTemplate } from '../../../../actions';
import { messages } from './EditWorkflowName.messages';
import { EditWorkflowNameProps } from './EditWorkflowName.types';

const EditWorkflowName: FC<EditWorkflowNameProps> = (props) => {
    const { templateName } = props;

    const [workflowName, setWorkflowName] = useState(templateName);
    const [isEditWorkflowNameOpen, setIsEditWorkflowNameOpen] = useState(false);
    const dispatch = useDispatch();

    const onTemplateNameChange = useCallback((value: string) => {
        setWorkflowName(value || '');
    }, []);

    const onTemplateNameSave = useCallback(() => {
        dispatch(renameTemplate(workflowName));
        setIsEditWorkflowNameOpen(false);
    }, [dispatch, workflowName]);

    const onWorkflowEditOpen = useCallback(
        (open: boolean) => {
            setIsEditWorkflowNameOpen(open);

            if (!open) {
                setWorkflowName(templateName);
            }
        },
        [templateName]
    );

    return (
        <Dropdown
            open={isEditWorkflowNameOpen}
            placement='bottom'
            onOpen={onWorkflowEditOpen}
            width='max-content'
            activator={
                <Button startIcon={<EditIcon />} color='blue10' size='xsmall'>
                    {messages.edit}
                </Button>
            }
        >
            <Box spacing='16'>
                <Flex alignItems='end' justifyContent='space-between' width={342} wrap={false}>
                    <Flex grow={1}>
                        <TextField
                            label={messages.label}
                            value={workflowName}
                            size='small'
                            placeholder={messages.placeholder}
                            onChange={onTemplateNameChange}
                            required
                        />
                    </Flex>

                    <Button onClick={onTemplateNameSave} color='blue80' size='small' disabled={!workflowName}>
                        {messages.save}
                    </Button>
                </Flex>
            </Box>
        </Dropdown>
    );
};

export default EditWorkflowName;
